export default "__VITE_ASSET__284a5842__"